export const validate = (inputs) => {

    const errors = {};

    if (!inputs.title) {
        errors.title = "Please enter title";
    }

    if (!inputs.name) {
        errors.name = "Please enter name";
    }

    if (!inputs.testimonial) {
        errors.testimonial = "Please enter testimonial";
    }

    return errors;
}